import { render, staticRenderFns } from "./CustomerLayout.vue?vue&type=template&id=59bd3675&scoped=true&"
import script from "./CustomerLayout.vue?vue&type=script&lang=ts&"
export * from "./CustomerLayout.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerLayout.vue?vue&type=style&index=0&id=59bd3675&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bd3675",
  null
  
)

export default component.exports